import React from 'react';

function WelcomeStep({ nextStep, isFirstStep }) {
  return (
    <div className="bg-white bg-opacity-5 rounded-lg border border-gray-200 border-opacity-20 p-8 md:p-12 text-center">
      {/* Elena Logo/Brand */}
      <div className="mb-8">
        <img 
          src="/elena-logo-4.svg" 
          alt="Elena Logo" 
          className="h-16 mb-4 mx-auto block"
        />
        <h1 className="text-4xl md:text-5xl font-bold text-white">
          Welcome to Elena
        </h1>
      </div>

      {/* Welcome Message */}
      <div className="mb-8 space-y-4">
        <p className="text-xl text-gray-300 leading-relaxed">
          Your AI-powered job search companion is here to help you land your dream role.
        </p>
        <p className="text-lg text-gray-400">
          Let's get you set up with a personalized experience in just a few quick steps.
        </p>
      </div>

      {/* Trial Information */}
      <div className="bg-gradient-to-r from-blue-900 to-purple-900 bg-opacity-50 rounded-lg p-6 mb-8 border border-blue-500 border-opacity-30">
        <div className="flex items-center justify-center mb-3">
          <svg className="w-6 h-6 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-green-400 font-semibold">7-Day Free Trial</span>
        </div>
        <p className="text-gray-300 text-sm">
          Start your free trial today. No commitments, cancel anytime.
        </p>
      </div>

      {/* Features Preview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8 text-sm">
        <div className="text-center">
          <div className="bg-blue-500 bg-opacity-20 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
            <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <p className="text-gray-300 font-medium">AI Resume Analysis</p>
          <p className="text-gray-500 text-xs">Optimize your resume for each job</p>
        </div>
        
        <div className="text-center">
          <div className="bg-purple-500 bg-opacity-20 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
            <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <p className="text-gray-300 font-medium">Job Tracking</p>
          <p className="text-gray-500 text-xs">Organize your applications</p>
        </div>
        
        <div className="text-center">
          <div className="bg-green-500 bg-opacity-20 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
            <svg className="w-6 h-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <p className="text-gray-300 font-medium">Smart Insights</p>
          <p className="text-gray-500 text-xs">Get personalized advice</p>
        </div>
      </div>

      {/* CTA Button */}
      <div>
        <button
          onClick={nextStep}
          className="w-full md:w-auto px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-lg hover:from-blue-600 hover:to-purple-600 transform hover:scale-105 transition-all duration-200 shadow-lg"
        >
          Get Started
        </button>
        <p className="text-gray-500 text-xs mt-3">
          Takes less than 3 minutes to complete
        </p>
      </div>
    </div>
  );
}

export default WelcomeStep; 